export default [
  {
    path: '/administration/partnership',
    name: 'Partnership',
    component: () => import('@/views/administration/partnership'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/partnership/detail',
    name: 'PartnershipDetail',
    component: () => import('@/views/administration/partnership-detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/web/content',
    name: 'WebContent',
    component: () => import('@/views/administration/web-content'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/web/content/detail',
    name: 'WebContentDetail',
    component: () => import('@/views/administration/new-post-detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/newsletter',
    name: 'Newsletter',
    component: () => import('@/views/administration/newsletter'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/web/content/banner/detail',
    name: 'BannerDetail',
    component: () => import('@/views/administration/banner-detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/web/content/promotion/detail',
    name: 'PromotionDetail',
    component: () => import('@/views/administration/promotion-detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/account/audit',
    name: 'accountAuditPage',
    component: () => import('@/views/administration/account-audit'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/account/audit/detail',
    name: 'accountAuditDetail',
    component: () => import('@/views/administration/accountAuditDetail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/coupon/detail',
    name: 'CouponDetail',
    component: () => import('@/views/administration/coupon-detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/sme/coupon/detail',
    name: 'SmeCouponDetail',
    component: () => import('@/views/administration/sme-coupon-detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/sme/coupon/detail',
    name: 'SMECouponDetail',
    component: () => import('@/views/administration/sme-coupon-detail'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/administration/dashboardPage'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/quick/report',
    name: 'QuickQuoteReport',
    component: () => import('@/views/administration/quickQuoteReport'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/linkreport',
    name: 'LinkReport',
    component: () => import('@/views/administration/link-report'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/ticket/report',
    name: 'ticketReport',
    component: () => import('@/views/administration/ticketReport'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/gift',
    name: 'giftCard',
    component: () => import('@/views/administration/giftCard'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/web/content/promotions/detail',
    name: 'PromotionsDetail',
    component: () => import('@/views/administration/promotions-detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/web/content/promotions/product',
    name: 'PromotionsProductDetail',
    component: () => import('@/views/administration/promotions-product-detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/web/content/promotions/ad',
    name: 'PromotionsProductADDetail',
    component: () => import('@/views/administration/promotions-product-ad-detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/administration/trail-code/detail',
    name: 'TrailCodeDetail',
    component: () => import('@/views/administration/trail-code-detail'),
    meta: {
      keepAlive: false
    }
  },
  // {
  //   path: '/post/preview',
  //   name: 'PostPreview',
  //   component: () => import('@/views/administration/post-preview-page'),
  //   meta: {
  //     keepAlive: false
  //   }
  // }
  {
    path: '/admin-cms',
    name: 'admin-cms',
    component: () => import('@/views/administration/components/cms'),
    children:[
      {
        path: 'promotions',
        name: 'Promotions',
        component: () => import('@/views/administration/components/webcontent/promotions'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'blog',
        name: 'Blog',
        component: () => import('@/views/administration/components/webcontent/news'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'notice',
        name: 'Notice',
        component: () => import('@/views/administration/components/webcontent/notice'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'coupons',
        name: 'Coupons',
        component: () => import('@/views/administration/components/webcontent/coupons.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'campaign-code',
        name: 'CampaignCode',
        component: () => import('@/views/administration/components/webcontent/campaign-code'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'trial-codes',
        name: 'TrialCodes',
        component: () => import('@/views/administration/components/webcontent/trial-codes.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'communications',
        name: 'Communications',
        component: () => import('@/views/administration/components/webcontent/communications.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'blog-ad',
        name: 'BlogAd',
        component: () => import('@/views/administration/components/webcontent/blog-ad.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'change-password',
        name: 'changePassword',
        component: () => import('@/views/administration/components/change-password'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'sms-log',
        name: 'SmsLog',
        component: () => import('@/views/administration/sms-log'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'email-log',
        name: 'EmailLog',
        component: () => import('@/views/administration/components/email-log'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'policy-log',
        name: 'PolicyLog',
        component: () => import('@/views/administration/policy-log'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'audit-log',
        name: 'AuditLog',
        component: () => import('@/views/administration/components/audit-log'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'block-list',
        name: 'BlockList',
        component: () => import('@/views/administration/components/block-list'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'marketing-report',
        name: 'MarketingReport',
        component: () => import('@/views/administration/components/webcontent/marketing-report'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'car-class-list',
        name: 'CarClassList',
        component: () => import('@/views/administration/carList/index'),
        meta: {
          keepAlive: false
        }
      },
    ],
    meta: {
      keepAlive: false
    }
  },
]
